import React from 'react'
import H1 from './H1.js';
import queryString from'query-string';
import '../Styles/Filter.css';
import axios from'axios';
class Filter extends React.Component{
  constructor(){
    super();
    this.state={
      restaurants:[],
      locations:[],
    }
  }
  navigate = (details) => {
    this.props.history.push(details);
  }
  navigate1 = (filter) => {
    this.props.history.push(filter);
  }
 componentDidMount(){
   const qs=queryString.parse(this.props.location.search);
   const{mealtype_id}=qs;
   const filterobj={
    mealtype_id:Number(mealtype_id)
   };  
 axios.get("https://z-5dan.onrender.com/getrestaurantsbymealtype2")
            .then(response => {
             this.setState({ restaurants: response.data ,filterobj});
              })
              .catch(error => {
                console.error("Error:", error);
              });
            }
render() {
    const {restaurants}=this.state;
    const { locations, } = this.state;
 return (
      <div>
   <H1 history={this.props.history} />
                  <h1 className="h1">Breakfast Places in Mumbai</h1>
                <div className="sidebar">
              <h2>Filter</h2>
            <h3> Select Location</h3>
              <div className="location-container">
              <select onChange={this.handleLocationChange}>
          <option value="">Select Location</option>
          {locations.map(location => (
            <option key={location.location_id} value={location.location_id}>{location.name},{location.city}</option>
          ))}
        </select>
       <h3> Cuisine </h3>
       <input type="checkbox" onChange={()=>this.handleCuisineChange1(1)}/>
      <label>North Indian</label>
      <br />
      <input type="checkbox"onChange={()=>this.handleCuisineChange2(2)}/>
      <label>South Indian</label>
      <br />
      <input type="checkbox"onChange={()=>this.handleCuisineChange3(3)}/>
      <label>Chinese</label>
      <br/>
      <input type="checkbox"onChange={()=>this.handleCuisineChange(4)}/> 
      <label>Fast Food</label>
      <br/>
      <input type="checkbox"onChange={()=>this.handleCuisineChange(5)}/>
       <label>Street Food</label>
       <h3>Cost for two</h3>
       <input type="radio" name="cost" onChange={() => this.handleCostChange(0, 500)} />
       <label>Less than ₹500</label>
        <br />
       <input type="radio" name="cost" onChange={() => this.handleCostChange(500, 1000)} />
       <label>₹500 to ₹1000</label>
        <br />
        <input type="radio" name="cost" onChange={() => this.handleCostChange3(1000, 1500)} />
        <label>₹1000 to ₹1500</label>
        <br />
        <input type="radio" name="cost" onChange={() => this.handleCostChange(1500, 2000)} />
       <label>₹1500 to ₹2000</label>
        <br />
        <input type="radio" name="cost" onChange={() => this.handleCostChange(2000, 5000)} />
        <label>More than ₹2000</label>
        <h3> Sort</h3>
      <input type="radio"name="price" onChange={this.sortByLowToHigh}/>
      <label>Price low to high</label>
      <br />
      <input type="radio"name="price" onChange={this.sortByHighToLow}/>
      <label>Price high to low</label>
    </div>
  </div>
{restaurants.map((restaurant, index) => (
                <div className="box" key={`${restaurant.location_id}_${index}`}>
                    <div>
                      <a href='/details'>  <img src={restaurant.image} alt={restaurant.name} /></a>
                      
                        <div className="box-content">
                            <h2>{restaurant.name}</h2>
                            <p>{restaurant.locality}, {restaurant.city}</p>
                            <p>{restaurant.address}</p>
                        </div>
                        <div className="box-hr" />
                        <div className="points">
                            <p>CUISINES: {restaurant.cuisine.map(c => c.name).join(', ')}</p>
                        </div>
                        <div className="word">
                            <p>COST-FOR-TWO: ₹{restaurant.min_price}</p>
                        </div>
                    </div>
                </div>
             ))}   
  <div className="boxs">
    {restaurants.length>0?
    <div className="pagination">
      <button>&laquo;</button>
      <button className="color" onClick={() => this.navigate('./filter')}>1</button>
      <button  className="color">2</button>
      <button  className="color">3</button>
      <button  className="color">4</button>
      <button  className="color">5</button>
      <button onClick={() => this.navigate('./details')}>&raquo;</button>
    </div>:null}
  </div>
  </div>
     )
    }
}
export default Filter ;
